import { motion } from "framer-motion";
import { BrushReveal } from "../animations/Transitions";
import { useState } from "react";
import { Link } from "react-router-dom";


const services = [
  { id: 1, title: "Cleaning", img: "https://plus.unsplash.com/premium_photo-1683141112334-d7d404f6e716?q=80&w=870", accent: "bg-blue-400" },
  { id: 2, title: "Fabrication", img: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?q=80&w=1000", accent: "bg-zinc-600" },
  { id: 3, title: "Painting", img: "https://images.unsplash.com/photo-1688372199140-cade7ae820fe?q=80&w=1470", accent: "bg-orange-500" },
  { id: 4, title: "Electricians", img: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?q=80&w=1000", accent: "bg-yellow-400" },
  { id: 5, title: "Wall Art", img: "https://plus.unsplash.com/premium_photo-1706430433638-b9f3183a496e?q=80&w=870", accent: "bg-purple-500" },
  { id: 6, title: "Gardening", img: "https://images.unsplash.com/photo-1683316924890-6a8c5ab10d29?q=80&w=871", accent: "bg-green-500" },
  { id: 7, title: "Plumbing", img: "https://plus.unsplash.com/premium_photo-1726761625778-1d13ba956d13?q=80&w=887", accent: "bg-cyan-500" },
  { id: 8, title: "Renovation", img: "https://plus.unsplash.com/premium_photo-1675601690595-9b9ff8a6bb2a?q=80&w=870", accent: "bg-indigo-500" },
  { id: 9, title: "Windows", img: "https://images.unsplash.com/photo-1544347120-e7b25160378a?q=80&w=711", accent: "bg-sky-500" },
  { id: 10, title: "Interior", img: "https://plus.unsplash.com/premium_photo-1692726042396-ee4ac06818be?q=80&w=406", accent: "bg-pink-500" },
  { id: 11, title: "WaterProofing", img: "https://plus.unsplash.com/premium_photo-1681589433893-da00988dce64?q=80&w=1374", accent: "bg-emerald-500" },
  { id: 12, title: "Many More", bg: "bg-gradient-to-br from-yellow-400 to-white", noImage: true },
];

const extraServices = [
  { id: 101, title: "Core Cutting", img: "https://i.pinimg.com/736x/4b/d6/1f/4bd61f2380a89b0601d162ca50ed8e03.jpg" },
  { id: 102, title: "Rebaring", img: "https://i.pinimg.com/736x/c1/39/7c/c1397c2ae71dd9a09ca9366a8550b3b5.jpg" },
  { id: 103, title: "Breaker", img: "https://i.pinimg.com/736x/66/7e/ca/667ecaacd0caef009587c94389e854a2.jpg" },

  { id: 104, title: "Slab Cutting", img: "https://plus.unsplash.com/premium_photo-1663040322345-baaec777f56d?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
  { id: 105, title: "Wall Cutting", img: "https://plus.unsplash.com/premium_photo-1682086494571-65cc866fad9a?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
];

const ServicesGrid = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section id="services" className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">

      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-12"
      >
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
          Services we <span className="text-blue-600">Offer</span>
        </h2>

        <p className="text-gray-500 max-w-2xl mx-auto text-sm sm:text-base">
          Explore our recent work across multiple home maintenance services.
        </p>
      </motion.div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service) => (
          <motion.div
            key={service.id}
            whileHover={{ y: -8 }}
            transition={{ duration: 0.3 }}
            className={`group relative h-[300px] sm:h-[350px] lg:h-[420px] rounded-3xl overflow-hidden cursor-pointer shadow-lg
              ${service.noImage ? service.bg : ""}
            `}
          >
            {!service.noImage && (
              <motion.div {...BrushReveal} className="w-full h-full">
                <img
                  src={service.img}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
              </motion.div>
            )}

            {!service.noImage && (
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
            )}

            <div className={`absolute bottom-6 left-6 right-6 ${service.noImage ? "text-black" : "text-white"}`}>
              {!service.noImage && (
                <div className={`w-10 h-1 mb-3 ${service.accent}`} />
              )}

              <h3 className="text-xl sm:text-2xl font-bold">
                {service.title}
              </h3>

              {service.noImage ? (
                <button
                  onClick={() => setShowModal(true)}
                  className="mt-3 bg-black text-white px-4 py-2 rounded-full text-sm"
                >
                  More
                </button>
              ) : (
                <button className="border-b border-white/60 text-sm opacity-0 group-hover:opacity-100 transition">
                  BOOK SERVICE
                </button>
              )}
            </div>
          </motion.div>
        ))}
      </div>

      {/* MODAL */}
      {showModal && (
        <motion.div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 sm:p-6">
          <motion.div className="bg-white rounded-2xl p-4 sm:p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto relative">

            <button
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-4 text-xl"
            >
              ✕
            </button>

            <div className="flex justify-center w-full">
              <Link to="/" className="flex items-center gap-2">
                <img
                  src="/yashraj logo.jpg.jpeg"
                  alt="Yashraj Concrete Breaker"
                  className="w-20 h-20 sm:w-24 sm:h-24 object-contain"
                />

                <div className="flex flex-col items-center">
                  <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 leading-tight">
                    YASHRAJ
                  </h2>

                  <span className="text-brown-500 text-sm">
                    Concrete Breakers
                  </span>

                  <p className="text-gray-500 text-sm">
                    Our Services
                  </p>
                </div>

              </Link>
            </div>

            {/* First Row (3 cards) */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {extraServices.slice(0, 3).map((item) => (
                <div key={item.id} className="rounded-xl shadow-md">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="h-36 sm:h-40 w-full object-cover rounded-t-xl"
                  />
                  <div className="p-3">
                    <h3 className="font-semibold">{item.title}</h3>
                  </div>
                </div>
              ))}
            </div>

            {/* Second Row (centered) */}
            <div className="flex justify-center gap-6 mt-6 flex-wrap">
              {extraServices.slice(3).map((item) => (
                <div key={item.id} className="w-full sm:w-[48%] lg:w-[30%] rounded-xl shadow-md">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="h-36 sm:h-40 w-full object-cover rounded-t-xl"
                  />
                  <div className="p-3">
                    <h3 className="font-semibold">{item.title}</h3>
                  </div>
                </div>
              ))}
            </div>

          </motion.div>
        </motion.div>
      )}

    </section>
  );
};

export default ServicesGrid;
